import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";

/**
 * ContentWrap
 *  - ContentWrap for a MenuContentItem
 */
export function ContentWrap(props) {
  const className = `${style.wrapper} ${props.className}`;
  return <div className={className}>{props.children}</div>;
}

ContentWrap.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Array of MenuItem and Section
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

ContentWrap.defaultProps = {
  className: "",
};
